module.exports = __webpack_public_path__ + "static/media/footer-tab.adbb8d5c.png";